export const ASSETS_GET_ASSETS_COURSE_CONTENTS_REQUEST = 'ASSETS_GET_ASSETS_COURSE_CONTENTS_REQUEST';
export const ASSETS_GET_ASSETS_COURSE_CONTENTS_SUCCESS = 'ASSETS_GET_ASSETS_COURSE_CONTENTS_SUCCESS';
export const ASSETS_GET_ASSETS_COURSE_CONTENTS_FAIL = 'ASSETS_GET_ASSETS_COURSE_CONTENTS_FAIL';